import { useState } from "react";
import { post } from "../networking/RequestService";

const useUpdateTasksTime = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const updateTasksTime = async (taskIds, { zaman, period }) => {
        setLoading(true);
        setError(null);
        try {
            const payload = {
                fn: "updateTasksTime",
                taskIds: taskIds,
            };

            // If period is provided (1 day, 3 days, etc.), use period
            if (period !== undefined && period !== null) {
                payload.period = period;
            }

            // If zaman is provided (specific date selected via Other), use zaman
            if (zaman !== undefined && zaman !== null) {
                payload.zaman = zaman;
            }

            const res = await post(payload);
            return res.data;
        } catch (res) {
            setError(res.response?.data?.text || res.message);
            throw res.response?.data?.text || res.message;
        } finally {
            setLoading(false);
        }
    };

    return { updateTasksTime, loading, error };
};

export default useUpdateTasksTime;
